"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEmptyPaymentMethod = void 0;
function makeEmptyPaymentMethod() {
    return {
        creditCard: false,
        remittance: false,
    };
}
exports.makeEmptyPaymentMethod = makeEmptyPaymentMethod;
//# sourceMappingURL=PaymentMethod.js.map